import http from '../api/httpRequest.js'

export default {
	state: {
		webrtc: {},
		walletShowEnable: false, // 是否显示钱包
		walletWithdrawEnable: false, // 是否显示钱包中的提现
		walletWithdrawMessage: '' // 点击提现提示的内容
	},
	mutations: {
		setConfig(state, config) {
			state.webrtc = config.webrtc;
			state.walletShowEnable = config.walletShowEnable;
			state.walletWithdrawEnable = config.walletWithdrawEnable;
			state.walletWithdrawMessage = config.walletWithdrawMessage;
		},
		clear(state) {
			state.webrtc = {};
			state.walletShowEnable = false;
			state.walletWithdrawEnable = false;
			state.walletWithdrawMessage = '';
		}
	},
	actions: {
		loadConfig(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/system/config',
					method: 'GET'
				}).then((config) => {
					console.log("系统配置", config)
					context.commit("setConfig", config);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}

}